module.exports = "img/button-text-underlined.0bc4f3d.svg";